import { usePerms } from 'contexts/PermsContext';
import React from 'react';
import { useGetWorkplaceMembersQuery } from 'services/organization/organization.api';
import { getVisibleUsers } from 'utils/users/role.utils';
import { parseAcknowledgementList } from '../../utils/alarmUtils';

interface Props {
  acknowledged?: string[];
}


const AcknowledgedByList: React.FC<Props> = ({ acknowledged = [] }) => {
  const perms = usePerms();
  const visibleLevels = getVisibleUsers(perms);
  const { data: workplaceMembers = [] } = useGetWorkplaceMembersQuery(visibleLevels);

  return (
    <div className="alarm-acknowledged-list h-100 d-flex flex-column">
      <div className="alarm-dropdown-label fw-semibold mb-2">Acknowledged By:</div>
      {acknowledged.length === 0 ? (
        <div className="text-muted">No acknowledgements</div>
      ) : (
        <ul className="list-unstyled m-0 p-0 overflow-auto">
          {acknowledged.map((entry, idx) => {
            const { time, userId } = parseAcknowledgementList(entry);

            // Resolve member by userId and display the canonical email only.
            const matched = userId
              ? workplaceMembers.find((m: any) => [m.id, m.userId, m.uid, m.user_id, m.employeeId]
                  .some((id) => id != null && String(id) === String(userId)))
              : undefined;
            const emailToShow = matched?.email;

            // Only display lines for members we can resolve from the members API
            if (!emailToShow) return null;

            const key = matched?.id ?? userId ?? idx;
            return (
              <li key={`${key}_$${idx}`} className="py-1">
                <div className="d-flex w-100 justify-content-between align-items-center">
                  <span className="fw-semibold text-truncate">{emailToShow}</span>
                  {time ? <small className="text-muted ms-2">{time}</small> : null}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default AcknowledgedByList;
